// Module
var code = "<kform-form form=\"componentForm\"></kform-form> ";
// Exports
export default code;